import type { IInfluencer } from '../../../redux/buzzbridge/types';
import { resolveInfluencerDisplayAvatarUrl } from '../../../utils/influencerSocialAvatar';

export type BuzzBridgeProfileIncompleteField =
    | 'profile_photo'
    | 'name'
    | 'bio'
    | 'country'
    | 'categories'
    | 'languages'
    | 'date_of_birth';

export const BUZZ_BRIDGE_PROFILE_FIELD_LABELS: Record<BuzzBridgeProfileIncompleteField, string> = {
    profile_photo: 'Profile photo',
    name: 'Display name',
    bio: 'Bio',
    country: 'Country',
    categories: 'Content categories',
    languages: 'Languages',
    date_of_birth: 'Date of birth',
};

function hasProfilePhoto(influencer: IInfluencer): boolean {
    return Boolean(resolveInfluencerDisplayAvatarUrl(influencer));
}

/** Returns which “match quality” fields are still empty on the BuzzBridge creator profile. */
export function getBuzzBridgeProfileMissingFields(influencer: IInfluencer): BuzzBridgeProfileIncompleteField[] {
    const missing: BuzzBridgeProfileIncompleteField[] = [];

    if (!hasProfilePhoto(influencer)) missing.push('profile_photo');
    if (!influencer.name?.trim()) missing.push('name');
    if (!influencer.bio?.trim()) missing.push('bio');
    if (!influencer.country?.trim()) missing.push('country');

    const hasCategory = Boolean(influencer.categories?.some(c => String(c?.main ?? '').trim().length > 0));
    if (!hasCategory) missing.push('categories');

    const hasLanguage = Boolean(influencer.languages_spoken?.some(l => String(l ?? '').trim().length > 0));
    if (!hasLanguage) missing.push('languages');

    if (!influencer.date_of_birth?.trim()) missing.push('date_of_birth');

    return missing;
}

export function isBuzzBridgeProfileComplete(influencer: IInfluencer): boolean {
    return getBuzzBridgeProfileMissingFields(influencer).length === 0;
}
